module.exports = __webpack_public_path__ + "img/way_j_ax.d80de387.png";